import script from "./ClubPageMembersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubPageMembersTable.vue?vue&type=script&setup=true&lang=js"

import "./ClubPageMembersTable.vue?vue&type=style&index=0&id=b2b069be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2b069be"]])

export default __exports__